(() => {
  'use strict';
  const key = '__mxToteWeekend20261016';
  if (window[key]) {
    window[key].enforce();
    return;
  }
  const start = Date.parse('2026-10-16T00:00:00+02:00');
  const end = Date.parse('2026-10-19T00:00:00+02:00');
  const enforce = () => {
    const now = Date.now();
    if (now < start || now >= end) {
      document.querySelectorAll('[data-mx-tote-weekend]').forEach(node => node.remove());
    }
  };
  const state = { enforce, timer: null };
  window[key] = state;
  enforce();
  const now = Date.now();
  if (now >= start && now < end) {
    state.timer = window.setTimeout(enforce, end - now + 50);
  }
  window.addEventListener('pageshow', enforce);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) enforce();
  });
})();
